import classes from './Auth.module.css';
import { AuthActions } from '../store';
import { useDispatch } from 'react-redux';
const Auth = () => {
  const dispatch = useDispatch();

  const Logar =()=>{
    dispatch(AuthActions.login())
  }
  return (
    <main className={classes.auth}>
      <section>
        <form>
          <div className={classes.control}>
            <label htmlFor='email'>Email</label>
            <input type='email' id='email' />
          </div>
          <div className={classes.control}>
            <label htmlFor='password'>Password</label>
            <input type='password' id='password' />
          </div>
          <button onClick={Logar}>Login</button>
        </form>
      </section>
    </main>
  );
};

export default Auth;
